// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__GYBsd","footer":"ChangeClinic_footer__3BlMG"};